<template>
  <div class="layout horizontal layout-fixed">
      <div
        class="container"
        :style="style_left"
        :class="{[props.left_content_class]: true}"
      >
          <slot name="left-content" />
      </div>

      <div v-if="right_collumn_visible === true"
        class="container"
        :style="style_right"
        :class="props.right_content_class"
      >
          <slot name="right-content" />
      </div>
  </div>
</template>

<script setup>
  import {reactive,ref}              from 'vue';
  import {defineExpose, defineProps} from 'vue';

  const props = defineProps({
    left_content_class: {
      type    : String,
      default : null,
    },

    right_content_class: {
      type    : String,
      default : null,
    },
  })

  const style_right = reactive({
    'flex-grow'  : 1,
    'flex-shrink': 1,
    'flex-basis' : 'auto',
  });

  const style_left = reactive({
    'flex-grow'  : 0,
    'flex-shrink': 0,
    'flex-basis' : '20rem',
  });

  const right_collumn_visible = ref(true);

  const setRightCollumnVisibility = (value) => {
    if (value === right_collumn_visible.value) {
      return;
    }

    right_collumn_visible.value = value;
  }

  defineExpose({
    setRightCollumnVisibility : setRightCollumnVisibility,
  })

</script>
